export default "/icons/steam_icon.svg";